import { accessToken, CIPageHeader } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';
import AiServiceBreadcrumb from './AiServiceBreadcrumb';
import CipAiAgentStudio from './CipAiAgentStudio';
import { getAgentRuntimePublicUrl } from './agentRuntimeEnv';
import classes from './AiServicePage.module.scss';

const agentPublicBaseUrl = getAgentRuntimePublicUrl();

const AiServicePage = () => {
  const { t: translate } = useTranslation();

  return (
    <>
      <div>
        <AiServiceBreadcrumb />
        <div className={classes.header}>
          <CIPageHeader header={String(translate('common_top_navigation.txt_ai_service'))} />
        </div>
      </div>
      <div className={classes.body} data-testid="ai-service-page">
        <div className={classes.studio}>
          <CipAiAgentStudio
            authToken={accessToken.value}
            agentPublicBaseUrl={agentPublicBaseUrl}
          />
        </div>
      </div>
    </>
  );
};

export default AiServicePage;
